export default __webpack_public_path__ + "static/media/image1.7ae41360.png";